import { colors, fonts, scoreToColor } from "../tokens";

interface Props {
  label: string;
  score: number;
}

export function ScoreBar({ label, score }: Props) {
  const col = scoreToColor(score);
  return (
    <div style={{ marginBottom: 7 }}>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 2 }}>
        <span style={{ fontSize: 10, color: colors.text2, fontFamily: fonts.mono }}>{label}</span>
        <span style={{ fontSize: 10, color: colors.muted, fontFamily: fonts.mono, width: 22, textAlign: "right" }}>
          {Math.round(score)}
        </span>
      </div>
      <div style={{ height: 3, background: colors.border, borderRadius: 2, overflow: "hidden" }}>
        <div style={{ height: "100%", width: `${Math.min(score, 100)}%`, background: col, borderRadius: 2, transition: "width 0.6s ease" }} />
      </div>
    </div>
  );
}
